module.exports = __webpack_public_path__ + "static/img/jlt.07c7fcc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/itemImgs/jlt.jpg
// module id = T+mQ
// module chunks = 0